import { cn } from '#app/utils/misc.tsx'

/**
 * Gradient glow blob — positioned absolute within a relative parent.
 * Purely decorative, hidden from assistive technology.
 * Pass position, size, opacity and animation through `className`.
 */
export function GradientBlob({ className }: { className?: string }) {
	return (
		<div
			className={cn(
				'bg-gradient-brand absolute rounded-full opacity-20 blur-[100px]',
				className,
			)}
			aria-hidden="true"
		/>
	)
}
